/**
 * Branding Configuration
 * Multi-language brand names and assets
 */

export const BRANDING = {
  en: 'Safrjal OTP',
  ar: 'تحقق مع سفرجل',
  logo: '/logo.svg',
  favicon: '/favicon.png',
};

export default BRANDING;
